export const environment = {
    production: true,
    allowLogsInBrowser: true, // enable logs in QA/local
    shouldEncrypt: false, // ✅ Encryption ENABLED for PRE_PROD/PROD
    PAYLOAD_ENCRYPTION_KEY: 'f6b1d520593b17274ddc6074a8d89e9000ffb8602a1bad68e74481c18f69fc75', // ⚠️ CHANGE THIS!
	crpSk: "yd.,|fE?;&T1zS&Hnb?[~.py9RbR_s`>*;WohKhl$z4h2G4UbAQo(_.<G^y?@yj",
    regPageAccessOTPs: [
        "U2FsdGVkX189gp1GKBJD4hz5hUTNnVCZgJMkL+mFiLk=",
        "U2FsdGVkX1+MR6QZ7Vl+J5BbZDt8m14nGLaAE3GQlMs=",
        "U2FsdGVkX18VK1Fx66WD8pUvcfjgKL7lC+oZP3mcT68=",
        "U2FsdGVkX18C8fBzJkTZ1wOQSZCYTJJMP57IHWQefJs=",
        "U2FsdGVkX193jcBAUV6AZcq6UyBMrXsHQBew1LlenVI=",
    ],
    apiBaseUrl: "https://www.wfh-tech.in/api",
    inviteJitsiDomain: "wfh-tech.in/",   // Url for Jitsi invite --- change according development server
    webSocketUrl: "wss://www.wfh-tech.in/chat",
    yWebSocketUrl: "wss://wfh-tech.in/docs",

    // AI api Service URL
    aiHelpBotUrl: "https://warforhappiness.in/",
    aiServerUrlForTranscription: "https://warforhappiness.in",   // jitsi transcribe

    aiServerUrl: "https://www.warforhappiness.in",
    aiServerUrl2: "https://www.warforhappiness.in",  // Latest Server
    aiServerUrlForMeetingTranscription: "https://warforhappiness.in",   // meeting transcribe
    aiServerSecretKeyForLocal: "AIVijayiINS",    // this is used when ins hit from for localHost

    chatServiceSocketUrl: "wss://wfhtech.in:7443/ws",
    chatServiceSocketDomain: "wfhtech.in",
    jitsiMeetingUrl: "holden1107.startdedicated.com", // jitsi server ul
    gitClientId: "Ov23lipPoGO7xszvCrhk",
    githubRedirectURL: "https://github.com/login/oauth/authorize?client_id=",
    firebase: {
        apiKey: "AIzaSyB6TqrBCoDeUIOHd-pEyKBqI8UXOQzo3n0",
        authDomain: "wfhtse-9e4f9.firebaseapp.com",
        projectId: "wfhtse-9e4f9",
        storageBucket: "wfhtse-9e4f9.appspot.com",
        messagingSenderId: "557815013071",
        appId: "1:557815013071:web:a1f939f5c86cb01c8021ba",
        measurementId: "G-L8YSKZ477T",
        vapidKey: "BF7McBMuD6a82tltnQ0Q-mLiJ5cenhbOZbgWcGypl2N6SmZHrOvuvDSgRGt6Vd_9q1qjFv0v7DDXk5K4LGR7vo4",
    },

    featuresVisibility: {
        //Feature modules
        LeaveWorkflow: true, // Leave workflow feature to create/manage leaves
        GroupConversations: true, // Group conversations feature
        TimeLine: true, // TimeLine feature
        MeetingsWorkflow: true, // Meetings workflow feature

        //Feature components
        EditOrg: true, //Edit Org and Remove a user from organization component
        JitsiMeetRecordingAndAIAnalysis: false, // Jitsi meet recording and AI analysis component
		JiraUpload: true,
		disableViewOptionFromDashboard: false, // Disable view option from dashboard views dropdown.
    },
};
